import React, { useEffect, useState } from "react";
import { Button, Form, Input } from "antd";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { login } from "../../actions/auth";
import apiClient from "../../actions/api";
import openNotification from "../../components/Notifications/openNotification";
import isEmpty from "../../validations/is-empty";
import {
  LockOutlined,
  MailOutlined,
  SafetyCertificateOutlined,
} from "@ant-design/icons";
import LogoSrc from "../../assets/image/logo.svg";
import "../../style/auth/auth.scss";

const Login = ({ title }) => {
  // set title
  document.title = title;

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const authUser = useSelector((state) => state.auth);

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (authUser.isAuthenticated) {
      navigate("/dashboard");
    }
  }, [authUser, navigate]);

  const onFinish = (values) => {
    setLoading(true);

    apiClient
      .post("/users/login", values)
      .then((res) => {
        if (!isEmpty(res.data)) {
          if (res.data.verificationRequired) {
            navigate("/verify-email", {
              state: {
                email: res.data.email,
                verificationToken: res.data.verificationToken,
              },
            });
            openNotification(
              "info",
              "Verify your email",
              "We sent an 8-digit code to your email.",
            );
          } else {
            dispatch(login(res.data.token));
            openNotification("success", "Success", "You've signed in.");
          }
        }
        setLoading(false);
      })
      .catch((err) => {
        if (!isEmpty(err?.response?.data?.errors)) {
          err.response.data.errors.forEach((item) => {
            openNotification("error", "Validation Error!", item.msg);
          });
        }
        setLoading(false);
      });
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  const onGoTo = () => {
    navigate("/register");
  };

  return (
    <div className="product-auth-page">
      <div className="product-auth-shell">
        <aside className="product-auth-brand">
          <div className="product-auth-logo">
            <img src={LogoSrc} alt="" />
            <span>
              Resume <strong>Builder</strong>
            </span>
          </div>
          <div className="product-auth-brand-copy">
            <span className="product-auth-eyebrow">A Lovapextech product</span>
            <h1>Build stronger applications, faster.</h1>
            <p>
              Manage resumes, opportunities, interviews, and your team workflow
              from one secure workspace.
            </p>
          </div>
          <div className="product-auth-trust">
            <SafetyCertificateOutlined />
            <span>
              <strong>Secure workspace</strong>
              <small>Your account and application data stay protected.</small>
            </span>
          </div>
        </aside>
        <section className="product-auth-card">
          <div className="product-auth-heading">
            <span>Welcome back</span>
            <h2>Sign in to your account</h2>
            <p>Enter your credentials to continue to Resume Builder.</p>
          </div>
          <Form
            name="basic"
            layout="vertical"
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
          >
            <Form.Item
              label="Email"
              name="email"
              rules={[{ required: true, message: "Please input your email!" }]}
            >
              <Input
                size="large"
                prefix={<MailOutlined />}
                placeholder="you@company.com"
                autoComplete="email"
              />
            </Form.Item>

            <Form.Item
              label="Password"
              name="password"
              rules={[
                { required: true, message: "Please input your password!" },
              ]}
            >
              <Input.Password
                size="large"
                prefix={<LockOutlined />}
                placeholder="Enter your password"
                autoComplete="current-password"
              />
            </Form.Item>

            <div className="product-auth-forgot">
              <Button
                type="link"
                htmlType="button"
                onClick={() => navigate("/forgot-password")}
              >
                Forgot password?
              </Button>
            </div>

            <Form.Item className="product-auth-submit">
              <Button
                type="primary"
                size="large"
                htmlType="submit"
                loading={loading}
              >
                Sign In
              </Button>
            </Form.Item>
          </Form>
          <div className="product-auth-switch">
            New to Resume Builder?{" "}
            <Button type="link" htmlType="button" onClick={onGoTo}>
              Create an account
            </Button>
          </div>
        </section>
      </div>
    </div>
  );
};

export default Login;
